/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import linkedinIcon from "assets/img/icons/common/linkedin-svgrepo-com.svg";

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer className=" footer">
          <Container>
            <Row className=" row-grid align-items-center mb-5">
              <Col lg="6">
                <h3 className=" text-primary font-weight-light mb-2">
                  Follow us!
                </h3>
              </Col>
              <Col className="text-lg-center btn-wrapper" lg="6">
                <Button
                  className="btn-icon-only rounded-circle ml-1"
                  style={{
                    background: "#0077B5",
                    border: "none",
                    color: "#fff"
                  }}
                  href="https://www.linkedin.com/company/chisp/"
                  id="tooltipChispLinkedIn"
                  target="_blank"
                >
                  <span className="btn-inner--icon" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                    <img
                      src={linkedinIcon}
                      alt="LinkedIn"
                      style={{
                        width: "45%",
                        height: "45%",
                        objectFit: "contain",
                        display: "block",
                        filter: "invert(1) brightness(2)",
                        margin: "auto"
                      }}
                    />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltipChispLinkedIn">
                  Follow Chisp Technologies
                </UncontrolledTooltip>
              </Col>
            </Row>
            <hr />
            <Row className="align-items-center">
              <Col md="12">
                <div className="copyright text-center">
                  © {new Date().getFullYear()} Chisp
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default SimpleFooter;
